import * as React from "react";
import "./Stepper.scss";
import ImportParts from "../ImportParts/ImportParts";
import InputRequirement from "../InputRequirement/InputRequirement";
import Analyze from "../Analyze/Analyze";
import GenerateQuotePage from "../GenerateQuote/GenerateQuote";
import ViewResults from "../viewResults/ViewResults";

export default function HorizontalNonLinearStepper() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [modelName, setModelName] = React.useState("");
  const [partName, setPartName] = React.useState("");
  const [partId, setPartId] = React.useState(0);

  const onHandleSelectPart = (partDetails, viewResults) => {
    setModelName(
      partDetails.modelName
        ? partDetails.modelName
        : partDetails.PartName + "." + partDetails.ModelType
    );
    setPartName(partDetails.PartName);
    setPartId(partDetails.PartID);
    if (viewResults) {
      setActiveStep(3);
    }
    else {
      setActiveStep(1);
    }
  };

  const onHandleNext = (stepIndex) => {
    setActiveStep(stepIndex);
  };

  const renderContent = () => {
    switch (activeStep) {
      case 0:
        return <ImportParts onSelectPart={onHandleSelectPart} />;
      case 1:
        return (
          <InputRequirement
            handleNext={() => {
              onHandleNext(0);
            }}
            partName={partName}
            modelName={modelName}
            partId={partId}
          />
        );
      case 2:
        return (
          <Analyze
            handleNext={() => {
              onHandleNext(3);
            }}
            partName={partName}
            modelName={modelName}
            partId={partId}
          />
        );
      case 3:
        return (
          <ViewResults
            handleNext={() => {
              onHandleNext(4);
            }}
            partName={partName}
            modelName={modelName}
            partId={partId}
          />
        );
      case 4:
        return <GenerateQuotePage />;
      default:
        return <ImportParts onSelectPart={onHandleSelectPart} />;
    }
  };

  return (
    <section className="stepper-section">
      {renderContent()}
    </section>
  );
}
